import React, { Component } from "react";
import PropTypes from "prop-types";
import CookieConsent from '../cookie-consent/CookieConsent';
import Logo from "../logo/logo";
import GameButton from "../game-button/gameButton";
import AppStoreIcons from "../app-store-icons/appStoreIcons";
import ButtonWrapper from "../button-wrapper/buttonWrapper";
import Strings from "../../strings.json";
import Footer from "../footer/Footer";
import "./gameChooser.css";

export default class GameChooser extends Component {
  constructor(props) {
    super(props);
    this.onBeginSinglePlayerPressed = this.onBeginSinglePlayerPressed.bind(
      this
    );
    this.onBeginMultiPlayerPressed = this.onBeginMultiPlayerPressed.bind(this);
    this.onBeginTimedModePressed = this.onBeginTimedModePressed.bind(this);

    this.backgroundClassName = window.newbackgroundtest
      ? "game-chooser game-chooser-b"
      : "game-chooser";
  }

  componentDidMount() {
    var iframe = document.createElement("iframe");
    iframe.src = "/rubicon-banner.html?ad_type=banner";
    this.bannerAdContainer.appendChild(iframe);
  }

  onBeginSinglePlayerPressed() {
    this.trackBeginGameMode(this.props.gameModes.classic);
    this.gameModeButtonPressed(this.props.gameModes.classic);
  }

  onBeginMultiPlayerPressed() {
    this.trackBeginGameMode(this.props.gameModes.elimination);
    this.gameModeButtonPressed(this.props.gameModes.elimination);
  }

  onBeginTimedModePressed() {
    this.trackBeginGameMode(this.props.gameModes.timed);
    this.gameModeButtonPressed(this.props.gameModes.timed);
  }

  gameModeButtonPressed(mode) {
    this.props.beginGameHandler(mode);
  }

  trackBeginGameMode(mode) {
    window.dataLayer.push({
      eventAction: "Click",
      eventlabel: "Start Button",
      eventCategory: "Game",
      gametype: mode,
      event: "eventPush"
    });
  }

  renderClassicButtons() {
    if (!this.props.termsLoaded) {
      return <GameButton text="Loading" disabled />;
    } else {
      return (
        <div>
          <GameButton
            customClass="game-button--start"
            text="Classic"
            clickHandler={this.onBeginSinglePlayerPressed}
          />
          <GameButton
            customClass="game-button--start"
            text="Beat The Clock"
            clickHandler={this.onBeginTimedModePressed}
          />
        </div>
      );
    }
  }

  renderEliminationButton() {
    return (
      <ButtonWrapper>
        <GameButton
          id="elimination-start-btn"
          customClass={"start__btn start__multi-player-btn"}
          text={"Elimination Mode"}
          clickHandler={this.onBeginMultiPlayerPressed}
        />
      </ButtonWrapper>
    );
  }

  render() {
    return (
      <section className={this.backgroundClassName}>
        <Logo />
        <h2 className="game-chooser__title">
          <strong>{Strings.gameStart.title}</strong>
        </h2>
        <div
          className="game-chooser__title--sub"
          dangerouslySetInnerHTML={{ __html: Strings.gameStart.description }}
        />
        <div className="start">
          {this.renderClassicButtons()}
          {this.renderEliminationButton()}
        </div>
        <AppStoreIcons placementId="hp" />
        <div
          id="bannerAdContainer"
          className="banner-ad"
          ref={ref => (this.bannerAdContainer = ref)}
        >
          <a
            className="banner-ad__optout"
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.rubiconproject.com/privacy/consumer-online-profile-and-opt-out/"
          >
            Opt out of ads
          </a>
        </div>
        <CookieConsent />
        <Footer />
      </section>
    );
  }
}

GameChooser.propTypes = {
  gameModes: PropTypes.object,
  termsLoaded: PropTypes.bool,
  beginGameHandler: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/game-chooser/gameChooser.js